import type { ReactNode } from "react";

import type {
    AiTrackerReportsBrandOverviewBrandWithShare,
    AiTrackerReportsBrandOverviewCitationWithInfluence,
    AiTrackerReportsBrandOverviewPromptDataV2,
    AiTrackerReportsBrandOverviewPromptDateResponse,
    AiTrackerReportsBrandOverviewPromptsQuickFilterCounts,
    AiTrackerReportsBrandOverviewPromptsSidePanelResponse,
    AiTrackerReportsBrandOverviewPromptsTableFiltersDataResponse,
    AiTrackerReportsBrandOverviewPromptsTableResponseV2,
    AiTrackerReportsBrandOverviewSourceCategoryShare,
    AiTrackerReportsPromptsReportPromptsTableV2ListParams,
} from "@similarweb/pro-api-client";
import type { RangeValue } from "@similarweb/pro-logic-components/dist/filter-factory/src/compound/types/type-utils";

import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { QuickFilterId } from "./consts";

export const ChangeStatus = {
    New: "New",
    Lost: "Lost",
    Unchanged: "Unchanged",
} as const;
export type ChangeStatus = (typeof ChangeStatus)[keyof typeof ChangeStatus];

export const SentimentShiftStatus = {
    TurnedPositive: "Turned Positive",
    TurnedNegative: "Turned Negative",
} as const;
export type SentimentShiftStatus = (typeof SentimentShiftStatus)[keyof typeof SentimentShiftStatus];

export type PromptsResponse = AiTrackerReportsBrandOverviewPromptsTableResponseV2;
export type Citation = AiTrackerReportsBrandOverviewCitationWithInfluence;
export type PromptsRequestParams = AiTrackerReportsPromptsReportPromptsTableV2ListParams;
export type SourceCategoryShare = AiTrackerReportsBrandOverviewSourceCategoryShare;
export type BrandWithShare = AiTrackerReportsBrandOverviewBrandWithShare;
export type Prompt = AiTrackerReportsBrandOverviewPromptDataV2;
export type FilterCounts = AiTrackerReportsBrandOverviewPromptsQuickFilterCounts;
export type FiltersData = AiTrackerReportsBrandOverviewPromptsTableFiltersDataResponse;

export interface IQuickFilterState {
    quickFilterId?: QuickFilterId;
}

interface IPromptsFilterBase {
    sentimentTone?: string[];
    domains?: string[];
    topSourceCategories?: string[];
    citationGap?: string[];
    citationVolatility?: string[];
    brands?: string[];
    latestCitationStatus?: string[];
}

export type IPromptsApiFilterParams = Pick<
    AiTrackerReportsPromptsReportPromptsTableV2ListParams,
    | "searchTerm"
    | "topics"
    | "sentimentStatuses"
    | "minVisibility"
    | "maxVisibility"
    | "brands"
    | "domains"
    | "topSourceCategories"
    | "citationGap"
    | "citationVolatility"
    | "sentimentTone"
    | "latestCitationStatus"
    | "change"
    | "sentimentShift"
>;

export interface IPromptsFilterState extends IPromptsFilterBase {
    topicsFilter?: string[];
    mentionSentimentStatus?: string[];
    visibility?: RangeValue;
    change?: string[];
    sentimentShift?: string[];
}

export interface IPromptsSidePanelParams extends ILLMWidgetRequestParams {
    promptId: string;
}

export interface IRankedListTooltipRow {
    leftValue: ReactNode;
    rightValue: ReactNode;
}

export type PromptDateResponse = AiTrackerReportsBrandOverviewPromptDateResponse;
export type PromptsSidePanelResponse = AiTrackerReportsBrandOverviewPromptsSidePanelResponse;
